import { extractImageFrames } from '../../tools';
import type { WavespeedModelConfig } from '../types';

export const skyworkConfigs: Record<string, WavespeedModelConfig> = {
    'skyreels-v3-standard-single-avatar': {
        // https://wavespeed.ai/zh-CN/models/skywork-ai/skyreels-v3-standard/single-avatar
        apiPath: '/skywork-ai/skyreels-v3-standard/single-avatar',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, audioUri } = params;
            const [firstImage] = extractImageFrames(imagePrompt);
            return {
                prompt: prompt,
                // 图片 URL
                image: firstImage,
                // 音频 URL
                audio: audioUri,
            };
        },
    },
    'skyreels-v3-pro-single-avatar': {
        // https://wavespeed.ai/zh-CN/models/skywork-ai/skyreels-v3-pro/single-avatar
        apiPath: '/skywork-ai/skyreels-v3-pro/single-avatar',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, audioUri } = params;
            const [firstImage] = extractImageFrames(imagePrompt);
            return {
                prompt: prompt,
                // 图片 URL
                image: firstImage,
                // 音频 URL
                audio: audioUri,
            };
        },
    },
};